/**
 * /devhub/governance — Area C (Governance). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/governance')({ component: DevHubGovernance });

function DevHubGovernance() {
  return (
    <DevHubAreaShell
      title="Governance"
      subtitle="Approvals, ActionFrames, traces, FinOps, invites, and the platform map."
      pages={[
        { label: 'Requests (approval queue)', description: 'Approve/reject/reindex change-requests (the proven live surface).', status: 'live', to: '/devhub/requests' },
        { label: 'ActionFrame Ledger', description: 'Frames + nested results (live /api/control/actionframes).', status: 'live', to: '/devhub/action-frames' },
        { label: 'Traces', description: 'Guardrail / agent traces (live /api/control/traces).', status: 'live', to: '/devhub/traces' },
        { label: 'FinOps', description: 'Usage ledger + budgets + treemap (live /api/control/finops).', status: 'live', to: '/devhub/finops' },
        { label: 'Invites & Tenants', description: 'Tenant membership + invite (relying-party admin).', status: 'live', to: '/devhub/invites' },
        { label: 'Inbox', description: 'Operator notifications + secret requests (live /api/notifications).', status: 'live', to: '/devhub/inbox' },
        { label: 'System Map', description: 'Capability registry — the platform live system map.', status: 'live', to: '/devhub/system-map' },
        { label: 'Workflows', description: 'Workflow registry + script runtime classification.', status: 'live', to: '/devhub/workflows' },
        { label: 'Tool gateway', description: 'ToolGateway routes — provenance, purpose, approval state.', status: 'live', to: '/devhub/tool-gateway' },
        { label: 'Platform', description: 'Spokes/plugins, ToolGateway, evidence, persistence.', status: 'live', to: '/devhub/platform' },
      ]}
    />
  );
}
